import { useParams, useNavigate } from "react-router-dom";
import { EditTrainingPage } from "@/pages/EditTrainingPage";
import { useTrainerChatOutlet } from "./TrainerChatUserLayout";
import { tg } from "@/constants/telegram";
import { User } from "@/entities/user";

export const TrainerChatEditTrainingPage = () => {
  const { userId } = useTrainerChatOutlet();
  const { id } = useParams();

  return (
    <EditTrainingPage
      initData={tg.initData || ""}
      user={{} as User}
      fromUser={userId}
      isAdmin={false}
      backPath={`/trainer/clients/${userId}/trainings-program`}
    />
  );
};


